<template>
  <section>
    <!--intro section-->
    <div
      v-rellax="{ speed: -4, center: true }"
      class="carnival-left position-absolute d-none d-lg-block"
    >
      <img
        width="300px"
        src="../../assets/img/carnival-left.png"
        alt=""
        class=""
      />
    </div>
    <div
      v-rellax="{ speed: -4, center: true }"
      class="carnival-right position-absolute d-none d-lg-block"
    >
      <img
        width="300px"
        src="../../assets/img/carnival-right.png"
        alt=""
        class=""
      />
    </div>
    <div class="container">
      <div class="row">
        <div class="col-10 offset-1 text-center col-lg-8 offset-lg-2">
          <h1
            class="page-title text-gradient mb-2"
            data-aos="fade-right"
            data-aos-easing="ease-in-out-quad"
            data-aos-once="true"
            data-aos-duration="1000"
          >
            {{ content.title }}
          </h1>
          <h4
            class="text-gradient text-bold page-ubtitle mb-0"
            data-aos="fade-right"
            data-aos-easing="ease-in-out-quad"
            data-aos-once="true"
            data-aos-delay="500"
            data-aos-duration="1000"
          >
            {{ content.subtitle }}
          </h4>
          <h4
            style="margin-top: 30px; font-size: 30px"
            class="text-black text-xl text-bold"
            data-aos="fade-right"
            data-aos-easing="ease-in-out-quad"
            data-aos-once="true"
            data-aos-delay="500"
            data-aos-duration="1000"
          >
            Schedule, Artists & Activities
          </h4>
          <div
            id=""
            class="d-flex justify-content-center mt-0 mt-md-5 animated bounce w-100"
            style="z-index: 1"
          >
            <span
              class="bg-white section-nav pointer"
              @click="scrollToSection('scroll-down')"
              data-aos="fade-down"
              data-aos-duration="3000"
              data-aos-easing="ease-in-out-back"
              data-aos-offset="-500"
              data-aos-once="true"
            >
              <img src="../../assets/svg/arrow-down.svg" alt="" class="" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <!--END intro section-->

    <!--schedule section-->
    <div id="scroll-down" class="img-schedule mt-n4 py-95">
      <div class="container">
        <div class="row">
          <div class="col-xl-10 offset-xl-1 col-lg-8 offset-lg-2">
            <div
              class="section-sch"
              v-for="(date, index) in schedule"
              :key="`date-${index}`"
            >
              <h2
                class="text-white font-weight-bold mb-3"
                data-aos="slide-up"
                data-aos-offset="100"
                data-aos-easing="ease-out-back"
              >
                {{ date.date }}
              </h2>
              <h6
                data-aos="slide-up"
                data-aos-offset="100"
                data-aos-easing="ease-out-back"
              >
                {{ date.description }}
              </h6>
              <dl class="row text-white mt-4 px-3">
                <div class="w-100">
                  <div
                    class="row no-gutters justify-content-between"
                    v-for="(slot, index) in date.timeSlots"
                    :key="`slot-${index}`"
                  >
                    <dt
                      class="d-flex col-md-3 py-1"
                      data-aos="slide-up"
                      data-aos-offset="100"
                      data-aos-easing="ease-out-back"
                    >
                      <icon-vue
                        style="font-size: 5px"
                        class="mr-2 mt-3"
                        :class="setTagColor(index)"
                        icon="circle"
                        size="xs"
                      ></icon-vue>
                      <p class="m-0" style="padding-right: 10px">
                        {{ slot.start }}
                        <span v-if="slot.end">- {{ slot.end }}</span>
                      </p>
                    </dt>
                    <dd
                      class="d-flex flex-column col-md-9 py-1 m-0"
                      data-aos="slide-up"
                      data-aos-offset="100"
                      data-aos-easing="ease-out-back"
                    >
                      <!-- <p class="m-0">{{ slot.title }}</p> -->
                      <p
                        class="m-0 text-blue-50"
                        style="transform: translateY(-30px)"
                      >
                        <small class="text-bold subtitle-text">
                          {{ slot.subtitle }}
                        </small>
                      </p>
                    </dd>
                    <hr class="w-100 border-white" />
                  </div>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--END schedule section-->

    <!--what's on section-->
    <div class="whats-on py-95">
      <div class="container">
        <div class="row">
          <div class="col-xl-10 offset-xl-1 col-lg-8 offset-lg-2">
            <h1
              class="text-bold text-gradient f-41"
              data-aos="zoom-in"
              data-aos-easing="ease-in-out-back"
              data-aos-once="true"
              data-aos-duration="500"
            >
              {{ content.perfAreaTitleMain }}
            </h1>
            <h4
              class="text-bold text-blue mb-80"
              data-aos="zoom-in"
              data-aos-easing="ease-in-out-back"
              data-aos-once="true"
              data-aos-delay="600"
              data-aos-duration="500"
              v-if="mainAreas.length > 0"
            >
              {{ mainAreas.length }} Performance Areas
            </h4>

            <ul class="list-unstyled">
              <div v-for="(area, index) in mainAreas" :key="`area-${index}`">
                <li
                  class="media p-2 p-sm-0 flex-column flex-sm-row justify-content-center justify-content-sm-start"
                  data-aos="zoom-in-up"
                  data-aos-once="true"
                >
                  <icon-vue
                    style=""
                    class="mr-0 mr-sm-3"
                    :class="setTagColor(index)"
                    icon="circle"
                  ></icon-vue>
                  <div
                    class="d-flex align-items-start justify-content-center justify-content-sm-start flex-column flex-sm-row text-center text-sm-left"
                  >
                    <div
                      class="rounded-circle img-media mr-0 mr-sm-5 mb-2 mb-sm-0 cover-bg"
                      :style="{ 'background-image': `url(${area.img})` }"
                    ></div>
                    <div class="media-body perf-area">
                      <h5 class="mt-0 mb-1 text-blue">{{ area.name }}</h5>
                      <p
                        class="m-0 text-blue-off"
                        v-html="area.description.replace(/\n/g, '<br/>')"
                      ></p>
                    </div>
                  </div>
                </li>
                <hr />
              </div>
            </ul>
            <h1
              class="text-bold text-gradient mt-128 mb-74 f-36"
              data-aos="zoom-in"
              data-aos-easing="ease-in-out-back"
              data-aos-once="true"
              data-aos-duration="500"
            >
              {{ content.perfAreaTitleExtra }}
            </h1>
            <ul class="list-unstyled">
              <div v-for="(area, index) in subAreas" :key="`subArea-${index}`">
                <li
                  class="media p-2 p-sm-0 flex-column flex-sm-row justify-content-center justify-content-sm-start"
                  data-aos="zoom-in-up"
                  data-aos-once="true"
                >
                  <icon-vue
                    style=""
                    class="mr-0 mr-sm-3 carnival-icon"
                    :class="setTagColor(index)"
                    icon="circle"
                  ></icon-vue>
                  <div
                    class="d-flex align-items-center justify-content-center justify-content-sm-start flex-column flex-sm-row text-center text-sm-left"
                  >
                    <div
                      class="rounded-circle mr-0 mr-sm-5 mb-2 mb-sm-0 img-media cover-bg"
                      :style="{ 'background-image': `url(${area.img})` }"
                    ></div>
                    <div class="media-body perf-area">
                      <h5 class="mt-0 mb-1 text-blue font-weight-bold">
                        {{ area.name }}
                      </h5>
                      <p class="m-0 font-weight-bold text-blue-off">
                        {{ area.description }}
                      </p>
                    </div>
                  </div>
                </li>
                <hr />
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--END what's on section-->

    <!--carnival-bottom-->
    <div class="img-carnival-bottom">
      <!-- <div class="container">
        <div class="row">
          <div class="col-xl-10 offset-xl-1 col-lg-8 offset-lg-2 action-sect">
            <h2
              class="text-gradient text-bold f-36 mt-5 mb-3"
              data-aos="zoom-in"
              data-aos-easing="ease-in-out-back"
              data-aos-once="true"
            >
              {{ content.closing }}
            </h2>
            <div
              class="d-flex flex-column justify-content-center align-items-center flex-md-row justify-content-md-start"
            >
              <b-button
                class="btn-carnival bg-lilac px-5 px-md-4 mr-2 mr-md-4 my-2 text-bold"
                @click="goToTicketList"
                >Book Tickets
              </b-button>
              <b-button
                class="btn-carnival bg-blue px-5 px-md-4 mr-2 mr-md-4 my-2 text-bold"
                @click="downloadFile(getVendorRegFile.url)"
              >
                Vendor Registration
              </b-button>
              <b-button
                @click="toRoute('/contact?regTroupe=true')"
                class="btn-carnival bg-green-dull px-5 px-md-4 my-2 text-bold"
                >Troupe Registration
              </b-button>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <!--END carnival-bottom-->
  </section>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { dbRefs } from '../../services/firebase/init';

export default {
  data() {
    return {
      content: {},
      colorIndex: 0,
      contentFetched: false,
    };
  },
  //    firestore: {
  //      content: dbRefs.carnivalRef,
  //      schedule: dbRefs.scheduleRef,
  //      areas: dbRefs.perfAreasRef,
  //    },
  methods: {},
  computed: {
    ...mapState({
      schedule: (state) => state.content.schedule,
      areas: (state) => state.content.areas,
    }),
    ...mapGetters(['getVendorRegFile', 'getVendorTCFile']),
    mainAreas() {
      return this.areas.filter((area) => area.category === 'main');
    },
    subAreas() {
      return this.areas.filter((area) => area.category !== 'main');
    },
  },
  async mounted() {
    const [content] = await Promise.all([
      this.fetchDocument(dbRefs.carnivalRef),
      this.fetchCollection({
        ref: dbRefs.perfAreasRef,
        collectionName: 'areas',
      }),
    ]);
    this.content = content;
    this.contentFetched = true;
  },
};
</script>
<style scoped lang="scss">
.py-95 {
  padding: 95px 0 0;
}

.carnival-left {
  top: 15%;
}

.carnival-right {
  right: 0px;
  top: 10%;
}

.img-carnival-bottom {
  height: 600px;
  background: url('../../assets/img/carnival-bottom.png') no-repeat top left;
  background-size: cover;
}

.img-media {
  height: 105px;
  width: 105px;
  /*background: url("../../assets/img/diary.png");*/
  object-fit: cover;
}

hr[class='w-100 border-white'] {
  opacity: 0.11;
}

.whats-on {
  div div div {
    h1 {
      letter-spacing: -0.4px;
      margin-bottom: 21px;
    }

    h4 {
      font-size: 23px;
      line-height: 1.17;
      letter-spacing: -0.2px;
    }
  }
}

.media-body.perf-area {
  h5 {
    font-size: 21px;
    letter-spacing: -0.2px;
    color: #2b2e83;
    font-weight: bold;
  }

  p {
    font-size: 18.5px;
    font-weight: bold;
    line-height: 1.7;
    letter-spacing: -0.2px;
    color: #8384a4;
  }
}

.action-sect {
  .btn-carnival {
    /*height: 45px;*/
    font-size: 15px;
    font-weight: bold;
    /*line-height: 1.32;*/
  }
}

.carnival-icon {
  @media (max-width: 568px) {
    margin-top: 20px;
  }
}

.list-unstyled div li svg {
  @media (max-width: 576px) {
    margin-left: 25%;
  }
}
.subtitle-text {
  white-space: pre-line;
}
</style>
